import styled from 'styled-components';
import { Tag } from 'antd';
import { font, paymentVoucherStatusColor } from 'shared/utils/styles';

export const StyledTag = styled(Tag)`
  ${font.size(20)}
  ${font.regular}
  padding: 0px 10px;
  height: 24px;
  line-height: 1.2;
  border-radius: 4px;
  border: none;
  background-color: ${(props) => paymentVoucherStatusColor[props.type].backgroundColor};
  color: ${(props) => paymentVoucherStatusColor[props.type].color};
`;

export default StyledTag;
